import { lazy } from 'react';
import React from 'react';
// project imports
import MainLayout from '../layout/MainLayout';
import Loadable from '../ui-component/Loadable';
import AuthGuard from '../utils/route-guard/AuthGuard';
import DoctorChatGuard from '../utils/route-guard/DoctorChatGuard';
import { element } from 'prop-types';
import SearchPage from '../views/anatec/search-page';

// sample page routing
const SamplePage = Loadable(lazy(() => import('../views/dashboard-list')));
const CreatePatient = Loadable(lazy(() => import('../views/create-patient')));
const CreateHerotainCase = Loadable(lazy(() => import('../views/create-herotain-case')));
const ProfileSettings = Loadable(lazy(() => import('../views/profile-settings')));
const Contact = Loadable(lazy(() => import('../views/contact')));
const Promotions = Loadable(lazy(() => import('../views/promotions')));
const Clinical = Loadable(lazy(() => import('../views/clinical')));
const Patients = Loadable(lazy(() => import('../views/patients')));
const PatientApp = Loadable(lazy(() => import('../views/patient-app')));
const Calendar = Loadable(lazy(() => import('../views/calendar')));
const OrtheroGallery = Loadable(lazy(() => import('../views/gallery')));
const Academy = Loadable(lazy(() => import('../views/academy')));
const Viewer = Loadable(lazy(() => import('../views/viewer')));
const Viewer2 = Loadable(lazy(() => import('../views/viewer2')));
const CaseDetail = Loadable(lazy(() => import('../views/casedetail')));
const Store = Loadable(lazy(() => import('../views/store')));
const Notifications = Loadable(lazy(() => import('../views/notifications')));
const AddRefinement = Loadable(lazy(() => import('../views/add-refinement')));
const AddHerotain = Loadable(lazy(() => import('../views/add-herotain')));
const ConfirmationHerotain = Loadable(lazy(() => import('../views/confirmation-herotain')));
const AnalyzerIframe = Loadable(lazy(() => import('../views/analyser-iframe')));
const OperationUpload = Loadable(lazy(() => import('../views/operation-upload')));
const OperationUploadTwo = Loadable(lazy(() => import('../views/operation-upload-two')));
const OperationUploadThree = Loadable(lazy(() => import('../views/operation-upload-three')));
const Messages = Loadable(lazy(() => import('../views/messages')));
const PageNotFound = Loadable(lazy(() => import('../views/page-not-found')));
const ErrorPage = Loadable(lazy(() => import('../views/error-page')));
const CaseNotFound = Loadable(lazy(() => import('../views/case-not-found')));
const OperationAttach = Loadable(lazy(() => import('../views/operation-attach')));
const PaymentRoute = Loadable(lazy(() => import('../views/payment-route')));
const OutstandingInvoices = Loadable(lazy(() => import('../views/outstanding-invoices')));
const BillingAccount = Loadable(lazy(() => import('../views/billing-account')));
const FailureRoute = Loadable(lazy(() => import('../views/failure-route')));
const OperationUploadFour = Loadable(lazy(() => import('../views/operation-upload-four')));
const OperationUploadFive = Loadable(lazy(() => import('../views/operation-upload-five')));
const ContractUpload = Loadable(lazy(() => import('../views/contract-upload')));
const Appointment = Loadable(lazy(() => import('../views/appointment')));
const SearchCases = Loadable(lazy(() => import('../views/search-cases')));
const PatientRequest = Loadable(lazy(() => import('../views/patient-request')));
const ConsultationRequests = Loadable(lazy(() => import('../views/consultation-requests')));
const ConsultationCase = Loadable(lazy(() => import('../views/consultation-case')));
const ConsultantMonthlyReport = Loadable(lazy(() => import('../views/consultant-monthly-report')));
const SharedCases = Loadable(lazy(() => import('../views/shared-cases')));
const PeerShareRequests = Loadable(lazy(() => import('../views/peer-share-requests')));

// ==============================|| MAIN ROUTING ||============================== //
const SamplePageAnatec = Loadable(lazy(() => import('../views/anatec/main-panel-anatec')));
const AnatecCaseDetail = Loadable(lazy(() => import('../views/anatec/casedetail-anatec')));
const AnatecViewer = Loadable(lazy(() => import('../views/anatec/viewer-anatec')));
const AnatecCalendar = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecCalendar')));
const AnatecCalendarNew = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecCalendarNew')));
const AnatecMyUnsuitability = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecMyUnsuitability')));
const AnatecMyCases = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecMyCases')));
const AnatecGeneralStatistic = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecGeneralStatistics')));
const AnatecAnalysisRateStatistic = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecAnalysisRateStatistic')));
const AnatecAnalysisFeedbackList = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecAnalysisFeedbackList')));
const AnatecAnalysisCorrection = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecAnalysisCorrection')));
const AnatecAnalysisConfirmationFollow = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecAnalysisConfirmationFollow')));
const AnatecAnalysisSoftFollow = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecAnalysisSoftFollow')));
const AnatecProductionReportAnalysisImpressions = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecProductionReportAnalysisImpressions')));
const AnatecDoctorMatrix = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecDoctorMatrix')));
const AnatecCancelRequestList = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecCaseRequestList')));
const AnatecActiveRequestList = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecCaseRequestList')));
const AnatecDoctorDetail = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecDoctorDetail')));
const AnatecOperationUploadTwo = Loadable(lazy(() => import('../views/anatec/operation-upload-two')));
const AdviserOperationUpload = Loadable(lazy(() => import('../views/adviser/operation-upload-adviser')));
const AnatecQualityControlAnalysis = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecQualityControl')));
const AnatecPersonalQualityControlAnalysis = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecPersonelQualityControl')));
const AnatecTrendPersonel = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecTrendPersonel')));
const AnatecTrendAdmin = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecTrendAdmin')));
const AnatecModtecTrend = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecModtecTrend')));
const AnatecOperationUploadFive = Loadable(lazy(() => import('../views/anatec/operation-upload-five')));
const AnatecNotifications = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecNotifications')));
const AnatecMessages = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecMessages')));
const AnatecOperationUpload = Loadable(lazy(() => import('../views/anatec/operation-upload')));
const AnatecFollowListNew = Loadable(lazy(() => import('../views/anatec/caller-components/AnatecFollowListNew')));
const UrgentRequests = Loadable(lazy(() => import('../views/anatec/caller-components/UrgentRequests')));

// ADVISER (Danışman Hekim) portalı — views/adviser/ altında
const AdviserMainPanel = Loadable(lazy(() => import('../views/adviser/main-panel-adviser')));
const AdviserCaseDetail = Loadable(lazy(() => import('../views/adviser/casedetail-adviser')));
const AdviserViewer = Loadable(lazy(() => import('../views/adviser/viewer-adviser')));
const AdviserDoctorDetail = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserDoctorDetail')));
const AdviserCases = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserCases')));
const AdviserViewImpression = Loadable(lazy(() => import('../views/adviser/viewimpression-adviser')));
const AdviserViewAnalysis = Loadable(lazy(() => import('../views/adviser/viewanalysis-adviser')));
const AdviserCommentedCases = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserCommentedCases')));
const AdviserStatistic = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserStatistic')));
const AdviserNotifications = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserNotifications')));
const AdviserFollowListNew = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserFollowListNew')));
const AdviserQualityControl = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserQualityControl')));
const AdviserTrendPersonel = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserTrendPersonel')));
const AdviserGallery = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserGallery')));
const AdviserExceedingLimits = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserExceedingLimits')));
const AdviserAnalysisQualityControl = Loadable(lazy(() => import('../views/adviser/caller-components/AdviserAnalysisQualityControl')));
const Coupons = Loadable(lazy(() => import('../views/coupons')));
const TpsInbox = Loadable(lazy(() => import('../views/tps-inbox')));
const CaseCalendar = Loadable(lazy(() => import('../views/anatec/caller-components/CaseCalendar')));
const OrtheroChat = Loadable(lazy(() => import('../views/orthero-chat')));

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/main-panel',
            element: <SamplePage />
        },
        {
            path: '/main-panel-anatec',
            element: <SamplePageAnatec />
        },
        {
            path: '/viewer/:casePk/:pk',
            element: <Viewer />
        },
        {
            path: '/anatecviewer/:casePk/:pk',
            element: <AnatecViewer />
        },
        {
            path: '/viewer2/:casePk/:pk',
            element: <Viewer2 />
        },
        {
            path: '/create-patient/:step',
            element: <CreatePatient />
        },
        {
            path: '/create-herotain-case/:step',
            element: <CreateHerotainCase />
        },
        {
            path: '/profile-settings',
            element: <ProfileSettings />
        },
        {
            path: '/outstanding-invoices',
            element: <OutstandingInvoices />
        },
        {
            path: '/billing-account',
            element: <BillingAccount />
        },
        {
            path: '/promotions',
            element: <Promotions/>
        },
             {
            path: '/contact',
            element: <Contact/>
        },
        {
            path: '/clinical',
            element: <Clinical/>
        },
        {
            path: '/appointments',
            element: <Appointment/>
        },
        {
            path: '/patients',
            element: <Patients/>
        },
        {
            path: '/patient-app',
            element: <PatientApp/>
        },
        {
            path: '/calendar',
            element: <Calendar/>
        },
        {
            path: '/gallery',
            element: <OrtheroGallery/>
        },
        {
            path: '/academy',
            element: <Academy/>
        },
        {
            path: '/casedetail/:pk',
            element: <CaseDetail/>
        },

        {
            path: '/anateccasedetail/:pk',
            element: <AnatecCaseDetail/>
        },
        {
            path: '/notifications',
            element: <Notifications/>
        },
        {
            path: '/messages',
            element: <Messages/>
        },
        {
            path: '/store',
            element: <Store/>
        },
        {
            path: '/add-refinement',
            element: <AddRefinement/>
        },
        {
            path: '/add-herotain',
            element: <AddHerotain/>
        },
        {
            path: '/confirmation-herotain/:casePlanPkOrder',
            element: <ConfirmationHerotain/>
        },
        {
            path: '/analyser-iframe/:deneme',
            element: <AnalyzerIframe/>
        },
        {
            path: '/operation-upload/:casePk/:casePlanPk/:analysisPk',
            element: <OperationUpload/>
        },
        {
            path: '/anatec-operation-upload/:casePk/:casePlanPk/:analysisPk',
            element: <AnatecOperationUpload/>
        },
        {
            path: '/operation-upload-two/:casePk/:casePlanPk',
            element: <OperationUploadTwo/>
        },
        {
            path: '/operation-upload-three/:casePk/:casePlanPk',
            element: <OperationUploadThree/>
        },
        {
            path: '/operation-attach/:userPk/:planPk/:caseLink/:target',
            element: <OperationAttach/>
        },
        {
            path: '/success/:url_param/',
            element: <PaymentRoute/>
        },
        {
            path: '/fail/:url_param/',
            element: <FailureRoute/>
        },
        {
            path: '*',
            element: <PageNotFound/>
        },
        {
            path: '/error-page',
            element: <ErrorPage/>
        },
        {
            path: '/operation-upload-four/:casePk/:casePlanPk/:analysisPk',
            element: <OperationUploadFour/>
        },
        {
            path: '/operation-upload-five/:casePk/:casePlanPk/:analysisPk',
            element: <OperationUploadFive/>
        },
        {
            path: '/contract-upload/:doctorPk/:campaignPk/',
            element: <ContractUpload/>
        },
        {
            path: '/case-not-found',
            element: <CaseNotFound/>
        },
        {
            path: '/anatec-calendar',
            element: <AnatecCalendar />
        },
        {
            path: '/anatec-analysis-calendar',
            element: <AnatecCalendarNew />
        },
        {
            path: '/anatec-myunsuitability',
            element: <AnatecMyUnsuitability />
        },
        {
            path: '/anatec-cases',
            element: <AnatecMyCases />
        },
        {
            path: '/anatec-general-statistic',
            element: <AnatecGeneralStatistic />
        },
        {
            path: '/anatec-analysisrate-statistic',
            element: <AnatecAnalysisRateStatistic />
        },
        {
            path: '/anatec-analysis-feedback-list',
            element: <AnatecAnalysisFeedbackList />
        },
        {
            path: '/anatec-analysiscorrection-statistic',
            element: <AnatecAnalysisCorrection />
        },

        {
            path: '/anatec-analysisconfirmationfollow-statistic',
            element: <AnatecAnalysisConfirmationFollow />
        },

        {
            path: '/anatec-analysissoftfollow-statistic',
            element: <AnatecAnalysisSoftFollow />
        },
        {
            path: '/anatec-analysisproductionimpressions-statistic',
            element: <AnatecProductionReportAnalysisImpressions />
        },
        {
            path: '/anatec-analysisdoctormatrix-statistic',
            element: <AnatecDoctorMatrix />
        },
        {
            path: '/anatec-cancel-request-list',
            element: <AnatecCancelRequestList type="cancel" title="İptal İsteği Olan Vakalar" />
        },
        {
            path: '/anatec-active-request-list',
            element: <AnatecActiveRequestList type="active" title="Aktif İsteği Olan Vakalar" />
        },
        {
            path: '/anatec-doctordetail/:doctorPk',
            element: <AnatecDoctorDetail />
        },

        {
            path: '/anatec-operation-upload-two/:casePk/:casePlanPk',
            element: <AnatecOperationUploadTwo/>
        },
        {
            path: '/anatec-quality-control-analysis',
            element: <AnatecQualityControlAnalysis/>
        },
        {
            path: '/anatec-personal-quality-control-analysis',
            element: <AnatecPersonalQualityControlAnalysis/>
        },

        {
            path: '/anatec-trend-admin',
            element: <AnatecTrendAdmin/>
        },
        {
            path: '/anatec-modtec-trend',
            element: <AnatecModtecTrend/>
        },
        {
            path: '/anatec-trend',
            element: <AnatecTrendPersonel/>
        },
        {
            path: 'search-page',
            element: <SearchPage />
        },
        {
            path: 'search-cases',
            element: <SearchCases />
        },
        {
            path: '/anatec-operation-upload-five/:casePk/:casePlanPk/:analysisPk',
            element: <AnatecOperationUploadFive/>
        },
        {
            path: '/anatec-notifications',
            element: <AnatecNotifications/>
        },
        {
            path: '/anatec-messages',
            element: <AnatecMessages/>
        },
        {
            path: '/patient-request',
            element: <PatientRequest/>
        },
        {
            path: '/consultation-requests',
            element: <ConsultationRequests/>
        },
        {
            path: '/consultation-case',
            element: <ConsultationCase/>
        },
        {
            path: '/consultant-monthly-report',
            element: <ConsultantMonthlyReport/>
        },
        {
            path: '/shared-cases',
            element: <SharedCases/>
        },
        {
            path: '/peer-share-requests',
            element: <PeerShareRequests/>
        },
        {
            path: '/anatec-supervisor-follow-list',
            element: <AnatecFollowListNew />
        },
        {
            path: '/urgent-requests',
            element: <UrgentRequests />
        },
        {
            path: '/coupons',
            element: <Coupons />
        },
        {
            path: '/tps-inbox',
            element: <TpsInbox />
        },
        {
            path: '/orthero-chat',
            element: (
                <DoctorChatGuard>
                    <OrtheroChat />
                </DoctorChatGuard>
            )
        },
        {
            path: '/case-calendar',
            element: <CaseCalendar />
        },
        {
            path: '/main-panel-adviser',
            element: <AdviserMainPanel />
        },
        {
            path: '/adviser-cases',
            element: <AdviserCases />
        },
        {
            path: '/adviser-casedetail/:pk',
            element: <AdviserCaseDetail />
        },
        {
            path: '/adviserviewer/:casePk/:pk',
            element: <AdviserViewer />
        },
        {
            path: '/adviser-doctordetail/:doctorPk',
            element: <AdviserDoctorDetail />
        },
        {
            path: '/adviser-viewimpression/:pk',
            element: <AdviserViewImpression />
        },
        {
            // Adviser dosya yükleme sayfası — anatec operation-upload-two'ın adviser kopyası
            // (views/adviser/operation-upload-adviser), bağımsız tam sayfa form.
            path: '/adviser-operation-upload/:casePk/:casePlanPk',
            element: <AdviserOperationUpload />
        },
        {
            path: '/adviser-viewanalysis/:pk',
            element: <AdviserViewAnalysis />
        },
        {
            path: '/adviser-commented-cases',
            element: <AdviserCommentedCases />
        },
        {
            path: '/adviser-statistic',
            element: <AdviserStatistic />
        },
        {
            path: '/adviser-notifications',
            element: <AdviserNotifications />
        },
        {
            path: '/adviser-supervisor-follow-list',
            element: <AdviserFollowListNew />
        },
        {
            path: '/adviser-quality-control-analysis',
            element: <AdviserQualityControl />
        },
        {
            path: '/adviser-trend',
            element: <AdviserTrendPersonel />
        },
        {
            path: '/adviser-gallery',
            element: <AdviserGallery />
        },
        {
            path: '/adviser-exceeding-limits',
            element: <AdviserExceedingLimits />
        },
        {
            path: '/adviser-analysis-quality-control',
            element: <AdviserAnalysisQualityControl />
        }
    ]
};

export default MainRoutes;
